export const liveActionTypes = {
  SET_STATUS: "live/SetStatus",
  RECEIVE_MESSAGE: "live/ReceiveMessage",
  CONTEST_RECEIVE_MESSAGE: "live/ContestReceiveMessage",
  CLEAR_DATA: "live/ClearData",
  CONTEST_CLEAR_DATA: "live/ContestClearData",
  SET_WS_REF: "wsRef",
};
